import { useLocation } from 'react-router-dom';
import { useMenu } from '../../contexts/MenuContext';
import { useFavorites } from '../../contexts/FavoritesContext';
import { resolveMenuByPath } from '../../utils/menuResolve';
import './FavoriteStar.css';

/**
 * Yıldız ikonu — dolu (favori) / boş (favori değil).
 * Sidebar'daki "Favorilerim" grubu da bunu kullanır.
 */
export function StarIcon({ filled, size = 18 }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3.2l2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.9-5.4 2.9 1-6L3.2 9.6l6.1-.9L12 3.2z" />
    </svg>
  );
}

/**
 * "Favorilerim" yıldızı — Topbar'da sayfa başlığının yanında durur ve AÇIK OLAN SAYFAYI
 * favorilere ekler/çıkarır. Tek yerde durduğu için tüm ekranlar (liste, detay, pano)
 * ek bir değişiklik olmadan kapsanır.
 *
 * Açık URL bir menü öğesine bağlanamıyorsa (menüsüz yardımcı sayfa, /change-password vb.)
 * yıldız HİÇ çizilmez — favorilenemeyecek bir şeyi favori gibi göstermemek için.
 */
export function FavoriteStar() {
  const location = useLocation();
  const { resolvedMenus, menuItems } = useMenu();
  const { isFavorite, toggle } = useFavorites();

  const menus = (resolvedMenus && resolvedMenus.length > 0) ? resolvedMenus : menuItems;
  const match = resolveMenuByPath(menus, location.pathname);
  if (!match) return null;

  const id = match.id ?? match.Id;
  const label = match.title ?? match.Title ?? '';
  const on = isFavorite(id);

  return (
    <button
      type="button"
      className={`ui-fav-star${on ? ' is-on' : ''}`}
      onClick={() => toggle(id)}
      aria-pressed={on}
      aria-label={on ? `${label} favorilerden çıkar` : `${label} favorilere ekle`}
      title={on ? 'Favorilerden çıkar' : 'Favorilere ekle — sol menüde en üstte görünür'}
    >
      <StarIcon filled={on} />
    </button>
  );
}
